import apiServices from '../../ApiServices/request-handler';
import { requestHandler } from '../../utils/functions';
import { setFundLoading, setTransactions } from '../slices/fund-slice';
import {
  setAccountBalance,
  setBeneficiaryData,
  setBeneficiaryList,
  setBeneficiaryLoading,
  setBeneficiaryDeleteLoading,
  setExchangeRates,
  setTransactionList,
  setTransactionLoading,
  setTransferInfo,
  setTransferLoading,
  setActivateLoading,
  setFeeWithdrawal,
} from '../slices/transferSlice';

export const getTransferInfo = () => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: apiServices.getTransferInfo,
        setData: setTransferInfo,
      }),
    );
};

export const getAccountBalance = () => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: apiServices.getAccountBalance,
        setData: setAccountBalance,
      }),
    );
};

export const getExchangeRates = (params) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: apiServices.getExchangeRates,
        param_data: params,
        setData: setExchangeRates,
      }),
    );
};

export const getBeneficiaryList = () => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: apiServices.getBeneficiaryList,
        setData: setBeneficiaryList,
        setLoading: setTransactionLoading,
      }),
    );
};

export const createTransfer = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: apiServices.createTransfer,
        setLoading: setTransferLoading,
        param_data: data,
        isSuccessMessage: true,
        onDone: onDone,
      }),
    );
};

export const getTransferTransaction = (params) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: apiServices.getTransferTransaction,
        param_data: params,
        setLoading: setTransactionLoading,
        onDone: (data) => {
          dispatch(setTransactionList(data?.result));
        },
      }),
    );
};

export const getBeneficiaryData = () => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        apiService: apiServices.getBeneficiaryData,
        setData: setBeneficiaryData,
      }),
    );
};

export const createBeneficiary = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setTransferLoading,
        apiService: apiServices.createBeneficiary,
        param_data: data,
        onDone: onDone,
        isSuccessMessage: true,
      }),
    );
};

export const validateIban = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setBeneficiaryLoading,
        apiService: apiServices.validateIban,
        param_data: data,
        onDone,
        isErrorMessage: true,
      }),
    );
};

export const deleteBeneficiary = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setBeneficiaryDeleteLoading,
        apiService: apiServices.deleteBeneficiary,
        param_data: data,
        isSuccessMessage: true,
        onDone: () => {
          onDone();
        },
      }),
    );
};

export const cancelBeneficiary = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setActivateLoading,
        apiService: apiServices.cancelBeneficiary,
        param_data: data,
        isSuccessMessage: true,
        onDone: () => {
          onDone();
        },
      }),
    );
};

export const activateBeneficiary = (data, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setActivateLoading,
        apiService: apiServices.activateBeneficiary,
        param_data: data,
        isSuccessMessage: true,
        onDone: () => {
          dispatch(getBeneficiaryData());
          dispatch(getBeneficiaryList());
          onDone();
        },
      }),
    );
};
export const getTransactionHistory = (params) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setFundLoading,
        apiService: apiServices.getTransactionHistory,
        param_data: params,
        setData: setTransactions,
      }),
    );
};

export const getFeeWithdrawal = (params, onDone) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setTransferLoading,
        apiService: apiServices.getFeeWithdrawal,
        param_data: params,
        setData: setFeeWithdrawal,
        onDone
      }),
    );
};
